<div class="app-container">
  <app-toolbar *ngIf="isLoggedIn()"
               [userName]="getUsername()"
               [userRoles]="getUserRoles()"
               [system]="getSystem()"
               [country]="getCountry()"
               [allMenuItems]="allMenuItems"
               (loadBreadcrumb)="loadMenuOption($event)"
               (logout)="logout()">
  </app-toolbar>

  <ng-template [ngIf]="isLoggedIn() && currentUrl !== '/'">
    <app-breadcrumb-toolbar *ngIf="breadcrumb1"
                            [breadcrumb1]="breadcrumb1"
                            [breadcrumb2]="breadcrumb2"
                            [title1]="title1"
                            [title2]="title2"
                            [code]="code"
    >
    </app-breadcrumb-toolbar>
  </ng-template>
  <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" id="logged-in-content">
    <div *ngIf="showLateralMenu() && isLoggedIn()" fxFlex.gt-md="20" fxFlex.sm="100" fxFlex.xs="100">
      <app-lateral-menu
        [submenuItems]="submenuItems"
        [showTitle]="showLateralMenuTitle"
        [currentUrl]="currentUrl"
      ></app-lateral-menu>
    </div>
    <div fxFlex.gt-md="{{(!showLateralMenu() || !isLoggedIn()) ? '100' : '80'}}" fxFlex.sm="100" fxFlex.xs="100"
         [className]="isLoggedIn() ? 'view-content' : ''">
      <router-outlet></router-outlet>
    </div>
  </div>
<!-- Comentado porque ao loguearse cargaba un div en blanco/duplicábase login form -->
<!--  <ng-template [ngIf]="!isLoggedIn()">-->
<!--    <router-outlet></router-outlet>-->
<!--  </ng-template>-->

  <div class="footer">
    <footer>
      <span>Copyright 2021 All Rights Reserved</span>
      <img src="assets/img/weee_forum_logo.svg" alt="weee_forum_logo">
    </footer>
  </div>
</div>






